export default __webpack_public_path__ + "static/media/s663-1.a9cee47d.png";